module.exports = __webpack_public_path__ + "img/smile.3d2eaa40.gif";